import { gql } from '@apollo/client'

export const GET_CAREER_PATH = gql`
  query getCareerPath($country: Country!) {
    careerPath(country: $country) {
      careerPathType
      country
      level
      min
      max
    }
  }
`

export const CAREER_PATH_EVALUATION = gql`
  query careerPathEvaluation($employeeId: HashedId!) {
    careerPathEvaluation(employeeId: $employeeId) {
      salaryEvaluation
      bonusEvaluation
      summary
      salary
      targetBonus
    }
  }
`
